import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  PinterestIcon,
  PinterestShareButton,
  RedditIcon,
  RedditShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from 'react-share';

import { SUPPORT_TWITTER } from '@glass/common/modules/support/rock';
import makeStyles from '@glass/web/modules/theme/makeStyles';

import SocialShareLink from '@glass/shared/components/Content/Social/SocialShareLink';

const FACEBOOK = 'facebook';
const WHATSAPP = 'whatsapp';
const REDDIT = 'reddit';
const PINTEREST = 'pinterest';
const TWITTER = 'twitter';
const LINKEDIN = 'linkedin';
const EMAIL = 'email';

const useStyles = makeStyles()((theme, { size }) => ({
  root: {
    height: size,
    overflowY: 'hidden',
  },
  button: {
    marginLeft: theme.spacing(0.5),
  },
}));

function SocialShareLinks({ url, title, description, image, tags, size }) {
  const { classes } = useStyles({ size });
  const hashtags = useMemo(() => tags?.map((tag) => `#${tag}`), [tags]);

  return (
    <div className={classes.root}>
      <SocialShareLink
        Button={FacebookShareButton}
        Icon={FacebookIcon}
        className={classes.button}
        hashtag={hashtags?.[0]}
        label={FACEBOOK}
        size={size}
        url={url}
      />
      <SocialShareLink
        Button={RedditShareButton}
        Icon={RedditIcon}
        className={classes.button}
        label={REDDIT}
        size={size}
        title={title}
        url={url}
      />
      <SocialShareLink
        Button={LinkedinShareButton}
        Icon={LinkedinIcon}
        className={classes.button}
        label={LINKEDIN}
        size={size}
        source={process.env.NEXT_PUBLIC_BRAND_TITLE}
        summary={description}
        title={title}
        url={url}
      />
      <SocialShareLink
        Button={TwitterShareButton}
        Icon={TwitterIcon}
        className={classes.button}
        hashtags={hashtags}
        label={TWITTER}
        related={[SUPPORT_TWITTER]}
        size={size}
        title={title}
        url={url}
        via={SUPPORT_TWITTER}
      />
      {image ? (
        <SocialShareLink
          Button={PinterestShareButton}
          Icon={PinterestIcon}
          className={classes.button}
          description={description}
          label={PINTEREST}
          media={image}
          size={size}
          url={url}
        />
      ) : null}
      <SocialShareLink
        Button={WhatsappShareButton}
        Icon={WhatsappIcon}
        className={classes.button}
        label={WHATSAPP}
        size={size}
        title={title}
        url={url}
      />
      <SocialShareLink
        Button={EmailShareButton}
        Icon={EmailIcon}
        className={classes.button}
        label={EMAIL}
        size={size}
        subject={title}
        url={url}
      />
    </div>
  );
}

SocialShareLinks.defaultProps = {
  size: 30,
};

SocialShareLinks.propTypes = {
  description: PropTypes.string,
  image: PropTypes.string,
  size: PropTypes.number,
  tags: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string,
  url: PropTypes.string.isRequired,
};

export default SocialShareLinks;
